'use strict';
module.exports = [
  // type
  require('./Complex'),

  // construction function
  require('./function/complex')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/complex/index.js
// module id = 1344
// module chunks = 0